export default __webpack_public_path__ + "e2511b126f399c3fd10d9cd7261726e0.ttf";